import { RedirectRoute } from '../Routing/types';

const redirects: RedirectRoute[] = [
  {
    path: '/favourite-meals',
    redirectTo: '/day-plan/favourite-meals',
  },
];

export default redirects;
